import { MediaAnalysisProgress, MediaAnalysisStatus } from '@/common/model/media/mediaAnalysis'

export const CompetitorApiPath = {
  RUN_COMPETITOR: '/api/sites/{site_id}/competitor/run', // POST Run Competitor（バックグラウンド実行）
  GET_COMPETITOR_DETAIL: '/api/sites/{site_id}/competitor/history/{history_id}' // GET Get Competitor Detail
}

export type CompetitorApiPath = (typeof CompetitorApiPath)[keyof typeof CompetitorApiPath]

export interface GetCompetitorDetailVars {
  site_id: number
  history_id: number
}

// バックグラウンド実行の入力。分析対象（media_analysis_target_id）から入力を解決する
export interface RunCompetitorVars {
  site_id: number
  media_analysis_target_id?: number | null
  target_domain?: string
  competitor_domains?: string[]
  keyword_filter?: string | null
  keyword_exclude?: string | null
  include_ad_analysis?: boolean
  include_trends?: boolean
}

export interface RunCompetitorResponse {
  id: number
  analysis_type: string
  status: string // analyzing
}

export interface GetCompetitorDetailResponse {
  id: number
  input_data: Record<string, unknown>
  result_data: Record<string, unknown>
  summary: string | null
  status?: MediaAnalysisStatus
  progress?: MediaAnalysisProgress
  created_at: string | null
}
